class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('[js-blog-tag-link]');
    this.container = document.querySelector('.Blog_template_new');
    this.sectionId = this.container.getAttribute('id').replace('shopify-section-', '');

    this.init()
  }

  init() {
    this.links.forEach(link => {
      link.addEventListener('click', (e) => {

        this.links.forEach(link => {
          link.classList.remove('selected');
        })
        link.classList.add('selected');

        e.preventDefault();
        const url = link.dataset.url;
        
        fetch(`${location.origin}${url}?section_id=${this.sectionId}`)
        .then(resp => resp.text())
        .then(docs => {
          const ajaxHtml = new DOMParser().parseFromString(docs, 'text/html');
          const blogContainer = this.querySelector('[js-blog-container]');
          const ajaxBlogContainer = ajaxHtml.querySelector('[js-blog-container]');
          blogContainer.replaceWith(ajaxBlogContainer); 

          document.dispatchEvent(new CustomEvent('ajaxLoadMore:init'))

        })

      })
    })
  }
}

customElements.define('blog-section', BlogSection);